import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";


const CustomPrevArrow = (props) => {
    const { onClick, currentSlide } = props
    const isFirstSlide = currentSlide === 0

    return (
        <button
            className={`absolute -bottom-8 left-[calc(50%-120px)] z-10 ${isFirstSlide ? 'text-gray-300' : 'text-black'}`}
            onClick={onClick}
            aria-label="Previous slide"
        >
            <IoMdArrowBack size={34} />            
        </button>
    )
}

const CustomNextArrow = (props) => {
    const { onClick, currentSlide, slideCount } = props
    const isLastSlide = currentSlide === slideCount - 1

    return (
        <button
            className={`absolute -bottom-8 right-[calc(50%-120px)] z-10 ${isLastSlide ? 'text-gray-300' : 'text-black'}`}
            onClick={onClick}
            aria-label="Next slide"
        >
            <IoMdArrowForward size={34} />
            
        </button>
    )
}

const expertsData = [
    {
        name: "Connor Weaver",
        title: "13th Fastest U.S. Runner, Marathon PR 2:13:52",
        quote: <><span className="font-bold">Grüns has everything I need nutritionally</span> to help my body recover & feel energized. The amount of vitamin B12, Vitamin C, & Vitamin D3 is exactly what I need to keep training at a high level.</>,
        image: "https://cdn.shopify.com/s/files/1/0550/9614/8034/files/GrunsExpert_ConnorWeaver.webp?v=1721921214&width=1800"
    },
    {
        name: "Haley King",
        title: "Mountain Biking: 4x Top 5 Finishes, CA Enduro Pro",
        quote: <>Maintaining my energy for 4+ hours is crucial. Grüns is portable, healthy, and easy on the stomach. These gummies <span className="font-bold">provide a quick energy boost and help me hit my daily nutrient goals.</span></>,
        image: "https://cdn.shopify.com/s/files/1/0550/9614/8034/files/GrunsExpert_HaleyKing.webp?v=1721921214&width=1800"
    },
    {
        name: "Yegor Denisov-Blanch",
        title: "Master of Sport, Olympic Weightlifting & Powerlifting",
        quote: <>There's no cutting corners when pushing the limits. You need to go the extra mile in every aspect. With grüns I'm confident I'm <span className="font-bold">fueling my body with the best</span>. — Olympic Weightlifting PR 745 LBS (top 3).</>,
        image: "https://cdn.shopify.com/s/files/1/0550/9614/8034/files/GrunsExpert_YegorDenisov-Blanch.webp?v=1721921214&width=1800"
    },
    {
        name: "Madison Hughes",
        title: "2x USA Olympic Rugby and Team Captain",
        quote: <>When you're on the go, Grüns ensures you're <span className="font-bold">meeting all of your nutritional needs</span>. Grüns helps me fuel my body correctly so I can focus on everything else. And it tastes great too!</>,
        image: "https://cdn.shopify.com/s/files/1/0550/9614/8034/files/GrunsExpert_MadisonHughes.webp?v=1721921214&width=1800"
    }
]

const RecommendedByExpert = () => {
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const checkIsMobile = () => {
            setIsMobile(window.innerWidth < 768)
        }
        
        checkIsMobile()
        window.addEventListener('resize', checkIsMobile)
        
        return () => {
            window.removeEventListener('resize', checkIsMobile)
        }
    }, [])

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        centerMode: false,
        variableWidth: false,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
        dotsClass: "slick-dots flex justify-center items-center gap-2 pb-4",
        className: "expert-carousel"
    }

    const ExpertCard = ({ expert }) => (
        <div className="bg-white rounded-lg overflow-hidden w-full">
            <div className="aspect-w-4 aspect-h-3 bg-gray-200 h-[170px] flex items-center justify-center">
                <img src={expert.image} alt={expert.name} className='w-full h-full object-cover' />
            </div>
            <div className="pt-[20px]">
                <h3 className="font-semibold text-gray-700">{expert.name}</h3>
                <div className="text-[#1f8e57] font-medium mb-2">
                    {expert.title}
                </div>
                <p className="text-gray-700 text-[13px]">
                    "{expert.quote}"
                </p>
            </div>
        </div>
    )

    return (
        <div className="bg-white py-16">
            <div className="container-custom">
                <h2 className="text-[#008037] text-[30px] md:text-[35px] font-semibold tracking-tighter text-center mb-4 md:mb-12">
                    Recommended by Experts & Olympians
                </h2>
                
                {isMobile ? (
                    <div className="relative px-3 md:px-8 pb-12">
                        <Slider {...sliderSettings}>
                            {expertsData.map((expert, index) => (
                                <div key={index} className="w-full">
                                    <ExpertCard expert={expert} />
                                </div>
                            ))}
                        </Slider>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        {expertsData.map((expert, index) => (
                            <ExpertCard key={index} expert={expert} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}

export default RecommendedByExpert


